<template>
	<div class="section"><slot></slot></div>
</template>

<style scoped>
.section {
	overflow: hidden;

	box-sizing: border-box;

	display: flex;
	flex-direction: column;

	background: linear-gradient(
		83.45deg,
		rgba(2, 122, 255, 0.05) -1.65%,
		rgba(248, 254, 255, 0.05) 52.48%,
		rgba(2, 122, 255, 0.05) 104.15%
	);
	border-radius: 16px;
}

.section > * {
	margin: 0px 12px;
	padding: 12px 0px;
	display: flex;
	align-items: center;

	gap: 16px;
}

.section > *:not(:last-of-type) {
	border-bottom: 1px dashed var(--section-separator-color);
}
</style>
